var render = function () {
  var _vm=this;
  var _h=_vm.$createElement;
  var _c=_vm._self._c||_h;

  return _c('div', {
    attrs: {
      "id": "chart"
    }
  }, [_c('apexchart', {
    staticClass: "d-flex justify-content-end my-chart",
    attrs: {
      "width": "160",
      "height": "36",
      "type": "area",
      "options": _vm.chartOptions,
      "series": _vm.series
    }
  })], 1);
}
var staticRenderFns = []

export { render, staticRenderFns }